/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { object, string } from 'prop-types';
import { compose } from 'recompose';

import withPageView from '../../../helpers/tracking/hocs/withPageView';
import { trackData } from '../../../helpers/tracking/common/commonTrackingHelpers';

import { contentPageRoutes } from '../../../../routes/contentPageRoutes';

/**
 * Uses contentPageRoutes to determine valid paths.
 */
const ContentPageBuilder = ({ page, brand, currRecipeName }) => {
    trackData({
        action: 'track_content_page_data',
    });
    return (
        <Switch>
            {/* Public */
                contentPageRoutes.map((route, index) => {
                    const { Component, path } = route;
                    const keyRoute = `route${index}`;
                    return (
                        <Route
                            path={path}
                            key={keyRoute}
                            render={() => <Component page={page} brand={brand} currRecipeName={currRecipeName} />}
                        />
                    );
                })
            }
        </Switch>
    );
};

ContentPageBuilder.propTypes = {
    page: object.isRequired,
    brand: object.isRequired,
    currRecipeName: string,
};

ContentPageBuilder.defaultProps = {
    currRecipeName: '',
};

const enhance = compose(
    withPageView({
        // eslint-disable-next-line arrow-body-style
        pageViewSuccessTest: () => {
            return true;
        },
    }),
);

export default enhance(ContentPageBuilder);
